import {yup} from 'libs/yup'

export const schema = yup.object({
  subject: yup.string().max(100).label('件名'),
  body: yup.string().max(10000).label('カスタマイズ文'),
})

export type Schema = yup.InferType<typeof schema>
